import { ReadableErrorReq } from "./ReadableErrorReq";
import { getRuntimeApiUrl } from "./runtimeApiUrl";
import { getFbp, getFbc } from "./metaPixel";
import { hydrateUtmHeaders, syncUtmFromUrl } from "./utm";

export const apiReq = new ReadableErrorReq(getRuntimeApiUrl());
apiReq.headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};
// Capture UTMs from the landing URL synchronously at module load. This runs
// before the store fires its bootstrap request, so the first API calls of a
// UTM-tagged visit carry attribution rather than waiting on Page's post-paint
// effect. A fresh tagged touch replaces any prior campaign's params; otherwise
// we fall back to values stored earlier in this session.
syncUtmFromUrl(window.location.search, apiReq.headers);
hydrateUtmHeaders(apiReq.headers);
const fbp = getFbp();
if (fbp) {
  apiReq.headers["x-fbp"] = fbp;
}
const fbc = getFbc();
if (fbc) {
  apiReq.headers["x-fbc"] = fbc;
}
